import * as React from "react";
import type { SVGProps } from "react";

interface MechanicalIssueProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const MechanicalIssue = ({ cancelled = false, ...props }: MechanicalIssueProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M18.662 1.1a1.35 1.35 0 0 1 .442 2.204L16.46 5.946l.325 1.3 1.302.326 2.644-2.644a1.35 1.35 0 0 1 2.146.318l.057.123a7.851 7.851 0 0 1-9.143 10.615l-.236-.062-6.824 6.825a2.35 2.35 0 0 1-3.195.12l-.128-.12-2.122-2.121a2.35 2.35 0 0 1 0-3.324l6.828-6.828-.062-.234a7.85 7.85 0 0 1 1.866-7.213l.207-.215A7.85 7.85 0 0 1 18.662 1.1"
      />
      <path
        fill="#D8D8D8"
        d="M20.273 12.959a6.5 6.5 0 0 1-7.076 1.414l-7.42 7.42a1 1 0 0 1-1.414 0L2.242 19.67a1 1 0 0 1 0-1.414l7.422-7.422a6.502 6.502 0 0 1 8.485-8.486l-3.182 3.183.707 2.828 2.829.707 3.184-3.184a6.5 6.5 0 0 1-1.414 7.076"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M10.62 3.307a7.15 7.15 0 0 1 7.776-1.559.65.65 0 0 1 .213 1.061l-2.923 2.922.524 2.094 2.093.523 2.924-2.925a.65.65 0 0 1 1.018.125l.043.087a7.151 7.151 0 0 1-8.821 9.53l-.106-.038-7.124 7.125a1.65 1.65 0 0 1-2.216.107l-.117-.107-2.122-2.121a1.65 1.65 0 0 1 0-2.334l7.126-7.127-.035-.105a7.15 7.15 0 0 1 1.553-7.056zm6.096-.703a5.851 5.851 0 0 0-6.45 7.984.65.65 0 0 1-.143.707l-7.421 7.422a.35.35 0 0 0 0 .495l2.12 2.12a.35.35 0 0 0 .496 0l7.42-7.419a.65.65 0 0 1 .707-.141 5.851 5.851 0 0 0 7.99-6.454l-.046-.218-2.427 2.427a.65.65 0 0 1-.521.187l-.096-.016-2.828-.707a.65.65 0 0 1-.473-.473l-.707-2.829a.65.65 0 0 1 .17-.617l2.424-2.424z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default MechanicalIssue;
